export default "__VITE_ASSET__Zqkw8Ivo__"